import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AgencyMaster } from '../common-structure';
import {CustomerRegistrationService} from '../../../services/customer-registration/customer-registration.service';
import {LoadingService} from '../../../services/loading/loading.service';


@Component({
    selector: 'app-agency-dropdown',
    templateUrl: './agency-dropdown.component.html',
    styleUrls: ['./agency-dropdown.component.css'],
    standalone: false
})
export class AgencyDropdownComponent implements OnInit {

  @Input() agencyMasterList: AgencyMaster[];
  @Output() agencySelected: EventEmitter<AgencyMaster> = new EventEmitter<AgencyMaster>();
    public agencyList = [];
    public errorMessage = '';
    public tmssLoader;

    constructor(private customerRegistrationService: CustomerRegistrationService, public loader: LoadingService) {
        this.tmssLoader = this.loader;
    }

  ngOnInit() {
    this.tmssLoader.show();
    this.customerRegistrationService.getAllAgency().subscribe(data => {
      this.agencyList = data;
      this.tmssLoader.hide();
    }, error => {
      this.errorMessage = error;
      this.tmssLoader.hide();
    });
  }

  changeAgency($event) {
        this.agencySelected.emit($event);
    }
}
